/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const multiUploadJinglesRequestModelSchema = z.object({
    "key": z.string().describe("Уникальный ключ, по которому будет осуществляться сопоставление presigned url с загружаемым файлом"),
"fileName": z.string().max(100).describe("Имя файла"),
"duration": z.number().int().describe("Длительность трека (для типа файла - трек)")
    })